import { MktuClassWord } from '@/services/Api/generated'
import { MktuClassStore } from '@/store/Mktu/MktuClass'
import { MktuClassPrototype } from '@/store/Mktu/MktuClass/MktuClassPrototype'
import { toJS } from 'mobx'
import { MktuClassCategory } from '@/models/Mktu'
import { apiService } from '@/services/Api'
import { format } from '@/utils/dates/functions'

/**
 * Объединение двух списков
 * если в класс из второго списка есть в первом,
 * то объединяются выбранные слова
 */
export function joinMktuClasses(
  firstList: MktuClassStore[],
  secondList: MktuClassStore[]
) {
  const newList = [...firstList]

  for (const newClass of secondList) {
    const addedClass = firstList.find((i) => i.number === newClass.number)

    // Если класс уже добавлен объединяем слова
    if (addedClass != null) {
      const newSelectedWords = joinSelectedWordsNames(
        addedClass.selectedWordsNames,
        newClass.selectedWordsNames
      )
      addedClass.setSelectedWordsNames(newSelectedWords)
    } else {
      newList.push(newClass)
    }
  }

  return newList
}

/**
 * Объединяем два списка слов, отбросив повторяющиеся
 */
export function joinSelectedWordsNames(
  firstList: MktuClassWord['uuid'][],
  secondList: MktuClassWord['uuid'][]
): MktuClassWord['uuid'][] {
  const newList = [...firstList]
  for (const word of secondList) {
    if (!firstList.includes(word)) {
      newList.push(word)
    }
  }
  return newList
}

/**
 * Клонируем класс МКТУ
 */
export function cloneMktuClass(
  mktuClass: MktuClassStore,
  withSelectedWords: boolean = true
): MktuClassStore {
  const newMktuClass = new MktuClassPrototype(mktuClass).clone()

  if (withSelectedWords) {
    newMktuClass.setSelectedWordsNames(mktuClass.selectedWordsNames)
  }

  return newMktuClass
}

export function getTypeMktuClassByNumber(number: number) {
  if (number <= 34) {
    return MktuClassCategory.Product
  } else {
    return MktuClassCategory.Service
  }
}

export async function exportMktuListToFile(list: MktuClassStore[]) {
  const response = await apiService.mktu._exportRaw({
    exportRequest: {
      mktuList: list.map((c) => ({
        classNumber: c.number,
        selectedWords: c.selectedWordsNames,
      })),
    },
  })

  const contentDisposition = response.raw.headers.get('Content-Disposition')
  let filename = `brandside_export_${format(
    new Date(),
    'DD.MM.YYYY_HH.mm'
  )}.txt`
  if (contentDisposition) {
    const match = contentDisposition.match(
      /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
    )
    if (match && match[1]) {
      filename = match[1].replace(/['"]/g, '')
    }
  }

  const blob = await response.raw.blob()
  const blobUrl = window.URL.createObjectURL(blob)

  const element = document.createElement('a')
  element.setAttribute('href', blobUrl)
  element.setAttribute('download', filename)
  element.style.display = 'none'
  document.body.appendChild(element)
  element.click()

  // Очистка
  document.body.removeChild(element)
  window.URL.revokeObjectURL(blobUrl)
}
